<template>
  <div>cumulatives</div>
</template>
<script>
export default {
  name: 'Cumulatives',
}
</script>
